import { useMutation } from "@tanstack/react-query";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { verifyOtp } from "../api/authAPI";
import Spinner from "../components/UI/Spinner";
import TextField from "../components/UI/TextField";
import { useAuthStore } from "../store/authStore";

import bg from "../assets/signInBg.png";
import LoginHeader from "../components/UI/LoginHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";

const VerifyOTPPage = () => {
  const {
    register,
    handleSubmit,
    watch,
    reset,
  } = useForm();
  // get user from store
  const user = useAuthStore((state) => state.user)
  const userState = useAuthStore((state) => state)
  const { isLoading, isSuccess, mutate, data, error } = useMutation({
    mutationFn: verifyOtp,
    // onError(err) {
    //   console.log(err)
    //   toast.error("incorrect otp")
    // }
  });
  const navigate = useNavigate();
  const location = useLocation();
  // hit api on submit
  const submitlogin = () => {
    const otp = watch("otp");
    if (location?.state?.email) {
      mutate({ otp: otp, email: location.state.email });
    } else {

      mutate({ otp: otp, email: user.email });
    }
    // reset form
    reset();
  };

  const setToken = useAuthStore((state) => state.setToken);

  useEffect(() => {
    toast.error(error?.response?.data?.message)
  }, [error])
  useEffect(() => {
    if (isSuccess && data) {
      // add token to store
      setToken(data.data.token);
      // check if status is error
      if (!(data.data.success)) {
        toast.error(data.data.message);
      } else if (location?.state?.email) {
        setToken(data.data.data.token);
        navigate("/new-password", { state: location.state.email })
      } else {
        setToken(data.data.data.token)
        // navigate to drones
        navigate("/dashboard/");
      }
    }
  }, [isSuccess]);

  const otpValidation = (value) => {
    if (value.target.value.length > 7) {
      toast.error("Please Enter Valid Otp")
      return
    }
  }
  return (
    <>
      <ToastContainer />
      <div className="login-wrap w-screen h-screen flex items-center justify-center bg-slate-100">
        <img className="absolute w-full h-full" src={bg} alt="bg" />

        <div className="login-card z-10 w-3/12 p-8 bg-white rounded-xl">
          <LoginHeader />
          <br />
          <h1 className="text-3xl font-light">Verify Otp</h1>
          <br />
          <form onSubmit={handleSubmit(submitlogin)} className="form">
            <TextField
              label="OTP"
              placeholder={"6 digit OTP"}
              inputProps={{
                ...register("otp", { required: true, onChange: otpValidation }),
              }}
            />

            <a
              href="/login"
              className="text-tblu hover:underline cursor-pointer w-full"
            >
              Already a user? Login here
            </a>
            <br />
            <br />
            <button
              onClick={handleSubmit(submitlogin)}
              className="text-xl bg-tblu text-white grid items-center w-full p-4 rounded-xl"
            >
              {isLoading ? <Spinner /> : "Verify OTP"}
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default VerifyOTPPage;
